import React from 'react';
import propTypes from 'prop-types';

import { Card, Columns, Column } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import posed, { PoseGroup } from 'react-pose';

const UserData = posed.div({
  enter: {
    opacity: 1,
    width: 118,
    transition: {
      duration: 250,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    width: 0,
    transition: {
      duration: 250,
      ease: 'easeOut',
    },
  },
});

export function UserCard({ user, isCondensed, ...rest }) {
  const cardClassName = classNames('user-card', {
    'is-condensed': isCondensed,
  });

  return (
    <Card
      className={cardClassName}
      {...rest}
      title={`${user.name} - ${user.role}`}
    >
      <Columns isGapless>
        <Column tag="span" className="icon is-large" isSize="narrow">
          <FontAwesomeIcon icon="user-circle" size="3x" />
        </Column>
        <PoseGroup>
          {!isCondensed && (
            <Column tag={UserData} className="user-data" key="data">
              <p>{user.name}</p>
              <small>{user.role}</small>
            </Column>
          )}
        </PoseGroup>
      </Columns>
    </Card>
  );
}

UserCard.propTypes = {
  user: propTypes.shape({
    name: propTypes.string,
    bankName: propTypes.string,
    role: propTypes.string,
  }).isRequired,
  isCondensed: propTypes.bool.isRequired,
};
